import { Platform } from 'react-native';
import { API_URL, USE_HTTPONLY_COOKIES } from '../constants/config';
import { shouldUseCookieAuth } from './authSignInSignUp';

/**
 * httpOnly cookie auth only works when the API is same-origin with the web app.
 * Production serves the app from mycoloursense.com but the API is on Render —
 * third-party cookies are blocked on mobile Safari, so we fall back to Bearer tokens.
 */
export const isCookieAuthMode = (): boolean =>
  shouldUseCookieAuth({
    useHttpOnlyCookies: USE_HTTPONLY_COOKIES,
    platform: Platform.OS,
    apiUrl: API_URL,
    pageHost: typeof window !== 'undefined' ? window.location.host : null,
    hasWindow: typeof window !== 'undefined',
  });
